/** @module WBS/MilestoneReportMixin */
define([
	"dojo/_base/declare",
	"csi/reflection"
], function(declare, reflection) {

	return declare(null, {
		_addWbsEnabledClause: function(/*Query*/query) {
			query.Attr("WbsEnabled", xml.OP_EQUALS, true);
		},

		_addTypeClause: function(/*Query*/query) {
			var types = this._getWbsEnabledTypes();

			if (types.length == 1) {
				query.Type(types[0]);
			} else {
				var orClause = query.Or();
				for (var i = 0; i < types.length; i++) {
					orClause.Type(types[i]);
				}
			}
			return query;
		},

		_getWbsEnabledTypes: function() {
			var types = [];
			var node = this.getViewNode();
			if (!node) {
				// only time when view node will not exist is when resolving for custom view migration
				return this._maybeAddType(types, "Style");
			}

			var nodeType = node.$Type;

			// if we are on global milestone report, allow all types
			if (nodeType == "WbsAdmin") {
				return ["Collection", "Colorway", "EngineeringChange", "Food", "FormulatedMaterial", "Material", "Project", "ProjectLineItem", "SKU", "Style"];
			}

			if (nodeType == "MaterialSecurityGroup") {
				return this._maybeAddType(types, "Material");
			}

			this._maybeAddType(types, "Colorway");
			this._maybeAddType(types, "SKU");

			if (nodeType == "Style") {
				return types;
			}

			this._maybeAddType(types, "Style");

			if (nodeType == "Collection") {
				return types;
			}

			// assume nodeType is Season, Category1, or Category2
			return this._maybeAddType(types, "Collection");
		},

		_maybeAddType: function(/*array*/types, /*String*/type) {
			if (this._isWbsEnabled(type)) {
				types.push(type);
			}
			return types;
		},

		_isWbsEnabled: function(/*String*/type) {
			return reflection.getClass(type).getAttribute("WbsEnabled").getValue();
		}
	});
});